var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v("Thank You!")]),_c('h3',[_vm._v(" Thank you for participating in the survey. Your answers will help improve the organization. ")]),_c('p',[_vm._v("You should close this browser window to complete this session")])])
}]

export { render, staticRenderFns }